import { render } from "./SignUpConfirmPlan.vue?vue&type=template&id=1040d8f0&scoped=true"
import script from "./SignUpConfirmPlan.vue?vue&type=script&lang=js"
export * from "./SignUpConfirmPlan.vue?vue&type=script&lang=js"

import "./SignUpConfirmPlan.vue?vue&type=style&index=0&id=1040d8f0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1040d8f0"]])

export default __exports__